import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        {/* <a href="https://github.com/stecherm-git" target="_blank" rel="noreferrer"><GitHubIcon/></a> */}
        <a href="https://www.linkedin.com/in/martin-stecher-3408a3195/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
        <a href="mailto:stecherm01@gmail.com" target="_blank" rel="noreferrer"><EmailIcon/></a>
      </div>
      <p style={{textAlign: "center"}}>Martin Stecher</p>
    </footer>
  );
}

export default Footer;